import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from "react-router-dom";

import { Divider, Typography, Tabs, Slider, Form } from 'antd';

import { FormattedMessage, useIntl } from 'react-intl';

import ToConsume from './ToConsumeTypes';
import ToProduce from './ToProduceTypes'

import './index.less';

const { Title } = Typography;
const { TabPane } = Tabs;

const langContext = 'reserved-area.marketplace'

const marks = {
  25: '25',
  50: '50',
  75: '75',
  100: '100',
  125: '125',
  150: '150',
  175: '175',
  200: '200',
  225: '225',
  250: '250',
  275: '275',
  300: '300',
}

export default ({ }) => {
  const [loading, setLoading] = useState(false);
  const [radius, setRadius] = useState(1);
  useEffect(() => {
    setLoading(false);
  }, []);

  const intl = useIntl();

  const onHandleChange = (value) => {
    setRadius(value);
  };

  return (
    <div className="marketplace__waste">
      <Title level={2}><FormattedMessage id={`${langContext}.waste.title`} /></Title>
      <Divider />
      <Form.Item label={intl.formatMessage({ id: langContext + '.fields.radius' })+" (Km)"}>
        <Slider
          min={1}
          marks={marks}
          max={1000}
          onChange={onHandleChange}
          tooltipVisible />
      </Form.Item>
      <Divider />
      <Tabs defaultActiveKey="1">
        <TabPane tab={intl.formatMessage({ id: langContext + '.waste.to-consume.title' })} key="1">
          <ToProduce radius={radius} />
        </TabPane>
        <TabPane tab={intl.formatMessage({ id: langContext + '.waste.to-produce.title' })} key="2">
          <ToConsume radius={radius} />
        </TabPane>
      </Tabs>
    </div>
  );
}
